<template>
  <main-layout>
    <div class="main_container">
      <div v-if="testMode" class="main_log">
        <div id="fps-info"></div>
        <pre id="metadata-info"></pre>
      </div>
      <Header v-else />
      <div
        ref="main"
        class="main"
        :class="{ ['main_overflow']: routeName === 'home' }"
      >
        <loading v-if="isLoading" />
        <transition v-if="!mainLoading" name="fade">
          <router-view />
        </transition>
      </div>
    </div>
  </main-layout>
</template>

<script>
import Header from './Header.vue';
import Loading from '@/components/Loading.vue';
import MainLayout from '@/layouts/MainLayout.vue';
import { mapActions, mapState } from 'vuex';
import { clearTracer } from '@/utils/print';
import StorageService from '@/services/StorageService';

export default {
  name: 'Main',
  components: {
    Header,
    MainLayout,
    Loading,
  },
  data() {
    return {
      tokenExpireOpen: true,
      mainLoading: true,
    };
  },
  computed: {
    ...mapState({
      isLoading: (state) => state.common.isLoading,
      testMode: (state) => state.common.testMode,
    }),
    routeName() {
      return this.$route.name;
    },
  },
  mounted() {
    this.init();
    this.start();
    if (this.$route.query.testMode) {
      this.setTestMode(true);
    }
  },
  methods: {
    ...mapActions('common', [
      'start',
      'setTestMode',
      'setIsLoading',
      'initializeUserAndCameras',
    ]),
    async init() {
      clearTracer();
      try {
        this.mainLoading = true;
        this.setIsLoading(true);
        await this.initializeUserAndCameras();

        // initialize StorageService after avatar data is available
        // this ensures migration runs with proper avatar context
        StorageService;

        // ensure recent avatars are populated now that avatar data is available
        StorageService.ensureRecentAvatarsPopulated();

        // process eventid AFTER cameras are loaded
        // this handles initial app load with eventid in URL
        await this.processEventIdIfPresent();
      } catch (error) {
        console.error(error);
      } finally {
        this.setIsLoading(false);
        this.mainLoading = false;
      }
    },
    async processEventIdIfPresent() {
      // only process if we are navigating to home route with eventid
      if (this.$route.name !== 'home') {
        return;
      }

      const eventid = this.$route.query.eventid;
      if (!eventid) {
        return;
      }

      // delegate to store action
      await this.$store.dispatch('common/processEventId', { eventid });
    },
  },
};
</script>

<style lang="scss">
.main {
  display: flex;
  margin-top: 15px;
  flex: 1;
  max-height: 100%;
  overflow: hidden;
  > * {
    width: 100%;
  }
  &_log {
    position: fixed;
    top: 0;
    right: 0;
    height: 100%;
    width: 300px;
    background-color: wheat;
    z-index: 20;
  }
  &_container {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }
  &_content {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    max-height: 100%;
  }
  &_maxWidth {
    width: 1220px;
    margin: 0 auto;
    flex-grow: unset;
  }
}
</style>
